import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyNumberFormat',
  standalone: true
})
export class EmptyNumberFormatPipe implements PipeTransform {


  transform(value: any): string {

    if (value) {

      if (value == 0)
        return "";
      else
        return value;
    }
    else
      return "";
  }

}
